module.exports = __webpack_public_path__ + "img/seafire_header_logo.fcfedb49.svg";